import { useState } from "react";
import { Image } from "@imagekit/react";
import {
    Backdrop,
    Box,
    Typography
} from "@mui/material";

const apiUrlImgKit = process.env.REACT_APP_API_IMAGEKIT;

// PREVIEW BIGGER IMAGE
export function PreviewImage({
    open,
    onClose,
    src
}) {
    return (
        <Backdrop
            open={open}
            onClick={onClose}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 999,
                backdropFilter: "blur(1px)",
            }}
        >
            <Box
                onClick={(e) => e.stopPropagation()}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 2,
                }}
            >
                <Image
                    urlEndpoint={apiUrlImgKit}
                    src={src ? `${src}.jpg` : "NO_IMAGE.jpg"}
                    alt="Preview"
                    style={{
                        maxWidth: "80vw",
                        maxHeight: "80vh",
                        borderRadius: "8px",
                        boxShadow: "0 8px 32px rgba(0,0,0,0.5)"
                    }}
                    loading="eager"
                />

                <Typography
                    sx={{
                        fontWeight: 600,
                        color: "#fff"
                    }}
                >
                    {src}
                </Typography>
            </Box>

        </Backdrop>
    );
}

// IMAGE CUSTOM SIZE
export function CustomImage({
    src,
    alt = "Preview",
    width = 100,
    height = 100,
    previewImage = false,
    onClick,
}) {
    return (
        <Image
            urlEndpoint={apiUrlImgKit}
            src={src ? `${src}.jpg` : "NO_IMAGE.jpg"}
            alt={alt}
            width={width}
            height={height}
            onClick={onClick}
            style={{
                cursor: previewImage ? "pointer" : "default",
            }}
            loading="eager"
        />
    );
}